import mitt from 'mitt'

export const EventCommonBusKey = {
  showEduWelcomModal: 'showEduWelcomModal' //主站承接校园版，显示欢迎弹窗
}

const commoneEmitter = mitt()

export default commoneEmitter
